import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  CircularProgress,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import AppBreadcrumbs from "../../components/AppBreadcrumbs";
import toast, { Toaster } from "react-hot-toast";

import EditIcon from "@mui/icons-material/Edit";
import * as services from "./../../services/customer";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";

const CustomerGroupsPage = () => {
  const [customerGroups, setCustomerGroups] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  const [newGroup, setNewGroup] = useState({
    name: "",
    details: "",
    customers: "",
  });
  const navigate = useNavigate();

  useEffect(() => {
    fetchGroup();
  }, []);
  const fetchGroup = async () => {
    try {
      let res = await services.getGroup();
      const rawData = res.data?.data || [];
      const mapped = rawData.map((group, index) => ({
        id: index + 1,
        group_id :  group.id,
        name: group.name || "-",
        customers: group._count?.customers ?? 0,
        detail: group.detail,
        updated: new Date(group.createdAt).toLocaleString("th-TH", {
          dateStyle: "long",
          timeStyle: "short",
        }),
      }));
      setCustomerGroups(mapped);
    } catch (error) {
      console.error("Error fetching customers:", error);
    } finally {
      setLoading(false);
    }
  };
  const filteredRows = customerGroups.filter(
    (row) =>
      row.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      row.id.toString().toLowerCase().includes(searchTerm.toLowerCase())
  );
  const handleDialogOpen = () => setOpenDialog(true);
  const handleDialogClose = () => setOpenDialog(false);

  const handleAddGroup = async () => {
    try {
      let response = await services.addGroup(newGroup);
      toast.success("เพิ่มรายการสำเร็จ!");
      console.log("Product created successfully:", response);
    } catch (err) {
      toast.error("เพิ่มรายการไม่สำเร็จ!");
      console.error("Error creating product:", err);
    }
    fetchGroup();
    handleDialogClose();
  };
  const columns = [
    { field: "id", headerName: "No.", width: 200 },
    { field: "name", headerName: "ชื่อกลุ่ม", width: 400 },
    { field: "detail", headerName: "รายละเอียด", width: 400 },
  
    {
      field: "customers",
      headerName: "จำนวนซัพพลายเออร์",
      width: 200,
    },
    { field: "updated", headerName: "อัปเดตล่าสุด", width: 200 },
    {
      field: "actions",
      headerName: "จัดการ",
      width: 100,
      renderCell: (params) => (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            height: "100%",
            cursor: "pointer"
          }}
          onClick={() => navigate(`/customer_group/${params.row.id}`)}
        >
          <EditIcon color="primary" />
        </Box>
      ),
    }
  ];
  
  return (
    <Box p={3}>
      <Toaster position="bottom-right" reverseOrder={false} />
      <AppBreadcrumbs />
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        my={2}
      >
        <Typography variant="h5">จัดการกลุ่มซัพพลายเออร์</Typography>
        {/* <Button
          variant="contained"
          color="primary"
          startIcon={<AddIcon />}
          onClick={handleDialogOpen}
        >
          เพิ่มกลุ่ม
        </Button> */}
      </Box>
      <TextField
        label="พิมพ์เพื่อค้นหา"
        variant="outlined"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        sx={{ mb: 2, width: 500 }}
      />
      <Box sx={{ height: 600, width: "100%" }}>
        {loading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
            }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <DataGrid
            rows={filteredRows}
            columns={columns}
            pageSize={10}
            rowsPerPageOptions={[10]}
            disableSelectionOnClick
            getRowId={(row) => row.id}
          />
        )}
      </Box>
      {/* Dialog สำหรับเพิ่มกลุ่ม */}
      <Dialog
        open={openDialog}
        onClose={handleDialogClose}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>เพิ่มกลุ่มซัพพลายเออร์</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="ชื่อกลุ่ม"
            fullWidth
            value={newGroup.name}
            onChange={(e) => setNewGroup({ ...newGroup, name: e.target.value })}
          />
          <TextField
            margin="dense"
            label="รายละเอียด"
            fullWidth
            value={newGroup.details}
            onChange={(e) =>
              setNewGroup({ ...newGroup, details: e.target.value })
            }
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose}>ยกเลิก</Button>
          <Button onClick={handleAddGroup} variant="contained">
            บันทึก
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};
export default CustomerGroupsPage;
